import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import ApiData from 'typescript/interfaces/ApiData';
import {IPost} from 'typescript/models/Post';
import {RequestStatus} from 'typescript/types/RequestStatus';

export interface IState {
  getPubPosts: {
    data: IPost[];
    status: RequestStatus;
    meta: ApiData['meta'] | null;
  };
  updatePost: {
    status: RequestStatus;
  };
}

const initialState: IState = {
  getPubPosts: {
    status: 'uninitialized',
    data: [],
    meta: null,
  },
  updatePost: {
    status: 'uninitialized',
  },
};

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    setGetPubPostsData: (state, action: PayloadAction<IState['getPubPosts']['data']>) => {
      state.getPubPosts.data = action.payload;
    },
    setGetPubPostsMeta: (state, action: PayloadAction<IState['getPubPosts']['meta']>) => {
      state.getPubPosts.meta = action.payload;
    },
    setGetPubPostsStatusAC: (state, action: PayloadAction<IState['getPubPosts']['status']>) => {
      state.getPubPosts.status = action.payload;
    },
    setUpdatePostStatusAC: (state, action: PayloadAction<IState['updatePost']['status']>) => {
      state.updatePost.status = action.payload;
    },
  },
});

export default postsSlice;

export const {setGetPubPostsData, setGetPubPostsMeta, setGetPubPostsStatusAC, setUpdatePostStatusAC} =
  postsSlice.actions;
